import { message } from 'antd';

import { ChargePoint } from './../../../types/responses/ChargePoints';
import { GetStationStatusReturn } from './types';

import { COLORS } from '../../../utils/theme/colors';

export const parsedStations = (chargePointList: ChargePoint[]) =>
  chargePointList?.map(
    ({
      chargeBoxPk,
      chargeBoxId,
      description,
      active,
      locationLatitude,
      locationLongitude,
      connectors,
      origin,
    }) => {
      // MV2-1680: mesma regra do getMarkers — estação sem conector visível não deve aparecer
      // no autocomplete lateral do mapa. Backend mantém a estação na listagem (pro operador
      // conseguir editar na tabela) mas ela não deve ser selecionável no mapa.
      return (
        origin === 'MOVE' && connectors && connectors.length > 0 && {
          chargeBoxPk,
          chargeBoxId,
          description,
          active,
          locationLatitude,
          locationLongitude,
          connectors,
        }
      );
    },
  );

export const getStationStatus = (
  chargePoint: ChargePoint,
): GetStationStatusReturn => {
  let status: GetStationStatusReturn['status'] = 'start';

  chargePoint.connectors.forEach((connector) => {
    switch (connector.lastStatus.status) {
      case 'Charging':
      case 'Finishing':
      case 'Suspended_evse':
      case 'SuspendedEV':
        status = 'orange';
        break;
      case 'Reserved':
      case 'Preparing':
        status = 'orange';
        break;
      case 'Faulted':
      case 'Unavailable':
        status = status === 'start' ? 'gray' : status;
        break;
      case 'Available':
        status = status === 'start' || status === 'gray' ? 'green' : status;
        break;
      case 'Maintenance':
        status = 'darkBlue';
        break;
      default:
        status = 'green';
    }
  });

  return { status, name: chargePoint.description || chargePoint.chargeBoxId };
};

export const checkIfHasLocation = (item) => {
  if (!item.locationLatutide && !item.locationLongitude)
    message.error(
      `A estação ${
        item.description || item.chargeBoxId
      } não possui latitude e longitude cadastrados.`,
    );
};

export const colorIfSelected = (
  { description, chargeBoxId },
  selectedCharger,
  type,
) => {
  if (type === 'bg')
    return selectedCharger.description === description ||
      selectedCharger.chargeBoxId === chargeBoxId
      ? COLORS.primary
      : COLORS.transparentIcon;
  if (type === 'txt')
    return selectedCharger.description === description ||
      selectedCharger.chargeBoxId === chargeBoxId
      ? 'blue_text selected_row'
      : COLORS.lightDarkText;
};
